import Alert, { AlertProps } from "@mui/material/Alert";

export type { AlertProps };
export default Alert;
